import React, { useState, useEffect } from 'react';
import { THEME } from '../../utils/theme';
import api from '../../utils/api';
import Spinner from '../ui/Spinner';

const HiddenGemsModal = ({ onClose, onShowDetail }) => {
  const [games, setGames] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get('/api/games/hidden-gems').then(data => {
      setGames(data.games || []);
      setLoading(false);
    }).catch(() => setLoading(false));
  }, []);

  return (
    <div style={{ position: 'fixed', inset: 0, background: 'rgba(5,5,10,0.85)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000, backdropFilter: 'blur(20px) saturate(180%)', WebkitBackdropFilter: 'blur(20px) saturate(180%)' }} onClick={onClose}>
      <div style={{ background: `linear-gradient(145deg, ${THEME.bgElevated}, ${THEME.bgCard})`, borderRadius: '20px', padding: '24px', width: '95%', maxWidth: '500px', maxHeight: '85vh', overflow: 'auto', border: `1px solid ${THEME.border}`, boxShadow: `0 25px 80px ${THEME.shadowHeavy}`, animation: 'scaleIn 0.2s ease' }} onClick={e => e.stopPropagation()}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
          <h2 style={{ margin: 0, color: THEME.text, fontSize: '20px', fontWeight: '700', display: 'flex', alignItems: 'center', gap: '10px' }}>
            <span style={{ fontSize: '24px' }}>💎</span> Hidden Gems
          </h2>
          <button onClick={onClose} style={{ background: THEME.bgHover, border: 'none', borderRadius: '8px', padding: '8px 12px', color: THEME.textMuted, cursor: 'pointer' }}>✕</button>
        </div>
        <p style={{ color: THEME.textMuted, fontSize: '13px', marginBottom: '16px' }}>Highly rated games (7+) with under 2 hours playtime</p>

        {loading ? (
          <div style={{ display: 'flex', justifyContent: 'center', padding: '40px' }}><Spinner /></div>
        ) : games.length === 0 ? (
          <div style={{ textAlign: 'center', color: THEME.textMuted, padding: '40px' }}>No hidden gems found</div>
        ) : (
          <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
            {games.map(game => {
              const userData = game.user_data || {};
              const totalPlaytime = Object.values(userData).reduce((sum, u) => sum + (u.playtime || 0), 0) || (game.playtime_omega || 0) + (game.playtime_supe || 0);
              return (
                <div key={game.id} onClick={() => { onShowDetail(game); onClose(); }} style={{ display: 'flex', gap: '12px', alignItems: 'center', padding: '10px', background: THEME.bg, borderRadius: '10px', cursor: 'pointer', border: `1px solid ${THEME.border}` }}>
                  <img src={game.header_image} alt="" style={{ width: '70px', height: '40px', objectFit: 'cover', borderRadius: '6px' }} />
                  <div style={{ flex: 1, minWidth: 0 }}>
                    <div style={{ color: THEME.text, fontWeight: '600', fontSize: '13px', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{game.name}</div>
                    <div style={{ display: 'flex', gap: '8px', alignItems: 'center', marginTop: '4px', flexWrap: 'wrap' }}>
                      {Object.entries(userData).map(([username, data]) => data.rating && (
                        <span key={username} style={{ color: data.color || THEME.success, fontSize: '12px', fontWeight: '600' }}>{data.rating}/10</span>
                      ))}
                    </div>
                  </div>
                  <div style={{ color: THEME.textMuted, fontSize: '11px' }}>
                    {Math.round(totalPlaytime / 60)}h
                  </div>
                </div>
              );
            })}
          </div>
        )}
      </div>
    </div>
  );
};

export default HiddenGemsModal;
